import { getContent } from "./getContent";
import { convertToServerDate } from "./utils";

const $ = window.jQuery;
const pickmeup = window.pickmeup;
const datePick = document.querySelector(".js-date");
const regex = /(\d+)-(\d+)-(\d+)/;
let firstSelect = true;

export function getDateIndex(dates) {
	if (!dates) {
		dates = pickmeup(datePick).get_date(false);
	}
	const dateRange = dates.map(item => {
		return convertToServerDate(item.getTime());
	});
	return `${dateRange[0]} — ${dateRange[1]}`;
}

export default function dateFilter() {
	pickmeup.defaults.locales.ru = {
		days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
		daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
		daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
		months: [
			"Январь",
			"Февраль",
			"Март",
			"Апрель",
			"Май",
			"Июнь",
			"Июль",
			"Август",
			"Сентябрь",
			"Октябрь",
			"Ноябрь",
			"Декабрь",
		],
		monthsShort: [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		],
	};
	const PLUS_DAYS = new Date();
	PLUS_DAYS.setDate(PLUS_DAYS.getDate() + 7);

	const DAYS_OF_WEEK = pickmeup.defaults.locales.ru.daysMin.slice();
	DAYS_OF_WEEK.push(DAYS_OF_WEEK.shift());

	pickmeup(datePick, {
		flat: true,
		mode: "range",
		locale: "ru",
		render: dateLocal => {
			const week = dateLocal.toLocaleString("en", { weekday: "short" });
			const month = dateLocal.toLocaleString("en", { month: "short" });
			const day = dateLocal.toLocaleString("en", { day: "numeric" });
			const className = `${month} ${week} ${day}`;
			return { class_name: className };
		},
		instance_template: () => {
			return `<div class="pmu-instance">
						<nav>
							<button type="button" class="date__prev js-date-prev-month disabled" aria-label="prev month">
								<img src="/images/site/chevron-left.svg" alt="prev month">
							</button>
							<div class="pmu-month pmu-button"></div>
							<button type="button" class="date__next  js-date-next-month" aria-label="next month">
								<img src="/images/site/chevron-right.svg" alt="next month">
						  </button>
						</nav>
					</div>`;
		},
	});

	const datesField = $(".js-date-field");

	function setShowDates(dates) {
		let first = dates[0].toLocaleString("ru", {
			month: "numeric",
			day: "numeric",
			year: "numeric",
		});
		first = first.replace(new RegExp("-", "g"), ".");

		let last = dates[1].toLocaleString("ru", {
			month: "numeric",
			day: "numeric",
			year: "numeric",
		});
		last = last.replace(new RegExp("-", "g"), ".");
		if (first === last) {
			datesField.text(first);
		} else {
			datesField.text(`${first} — ${last}`);
		}
	}

	function setDisabledDates() {
		const days = $(".pmu-days .pmu-button");
		const disabledDates = $(".pmu-today").prevAll(".pmu-button");

		$.each(disabledDates, (index, element) => {
			$(element).addClass("disabled");
		});
		if (disabledDates.length >= days.length / 1.5) {
			pickmeup(datePick).next();
		}
	}

	function setRangeEdge(dates) {
		if (dates.length > 1) {
			// change month and day place to Date format

			const weekFirst = dates[0].toLocaleString("en", { weekday: "short" });
			const monthFirst = dates[0].toLocaleString("en", { month: "short" });
			const dayFirst = dates[0].toLocaleString("en", { day: "numeric" });
			const classNameFirst = `${monthFirst} ${weekFirst} ${dayFirst}`;
			const weekLast = dates[1].toLocaleString("en", { weekday: "short" });
			const monthLast = dates[1].toLocaleString("en", { month: "short" });
			const dayLast = dates[1].toLocaleString("en", { day: "numeric" });
			const classNameLast = `${monthLast} ${weekLast} ${dayLast}`;
			const selectedItems = $(".pmu-selected.pmu-button");
			$.each(selectedItems, (index, element) => {
				const item = $(element);
				if (item.hasClass(classNameFirst)) {
					item.addClass("first-selected");
				}
				if (item.hasClass(classNameLast)) {
					item.addClass("last-selected");
				}
			});
		} else {
			$(".pmu-selected.pmu-button").addClass("alone-selected");
		}
	}

	function setSelectedDatesToCenter() {
		const days = document.querySelector(".pickmeup .pmu-days");
		const firstSelected =
			days.querySelector(".pmu-button.first-selected") ||
			days.querySelector(".pmu-button.pmu-today") ||
			days.querySelector(".pmu-button.alone-selected");
		if (firstSelected) {
			days.scrollLeft = $(firstSelected).position().left;
		}
	}

	const dates = pickmeup(datePick).get_date(false);
	setDisabledDates();
	$(".pmu-prev").addClass("inactive");
	let datesLocal = dates;
	datePick.addEventListener("pickmeup-change", e => {
		datesLocal = e.detail.formatted_date;
		let firstDate;
		let first;

		if (firstSelect === true) {
			firstSelect = false;
			firstDate = new Date();
		} else {
			first = datesLocal[0].replace(regex, "$3-$2-$1");
			firstDate = new Date(first);
		}

		const last = datesLocal[1].replace(regex, "$3-$2-$1");
		let datesLocalCommon = [];
		const lastDate = new Date(last);
		datesLocalCommon.push(firstDate);
		datesLocalCommon.push(lastDate);
		datesLocalCommon = Array.from(new Set(datesLocalCommon));
		pickmeup(datePick).set_date(datesLocalCommon);
		getContent(getDateIndex(datesLocalCommon));
		setShowDates(datesLocalCommon);
		setTimeout(setRangeEdge.bind(null, datesLocalCommon), 30);
		setTimeout(setSelectedDatesToCenter, 30);
		$(".js-date-prev").removeClass("inactive");
		$(".date__show").show();
	});

	datePick.addEventListener("pickmeup-fill", () => {
		const currentMonth = new Date().toLocaleString("ru", { month: "long" });
		if (
			$(".pmu-month")[0]
				.textContent.toLowerCase()
				.includes(currentMonth)
		) {
			$(".pmu-prev").addClass("inactive");
		} else {
			$(".pmu-prev").removeClass("inactive");
		}
		const selectedDate = $(".pmu-days .pmu-selected.pmu-button");
		if (selectedDate.length === 1) {
			selectedDate.addClass("alone-selected");
		} else {
			selectedDate.last().addClass("last-selected");
			selectedDate.first().addClass("first-selected");
		}
		setDisabledDates();
	});

	$(".js-date-prev").on("click", () => {
		const days = document.querySelector(".pickmeup .pmu-days");
		const scroll = days.scrollLeft;
		days.scrollLeft = scroll - 40;

		const pickMonth = $(".pmu-month.pmu-button")
			.text()
			.toLowerCase();
		const currentMonth = new Date().toLocaleString("ru", { month: "long" });

		if (days.scrollLeft === 0) {
			$(".js-date-prev").addClass("inactive");
		}
		if (days.scrollLeft === 0 && !pickMonth.includes(currentMonth)) {
			$(".js-date-prev-month").trigger("click");
		}
	});

	let scroll;
	$(".js-date-next").on("click", () => {
		const days = document.querySelector(".pickmeup .pmu-days");
		if (scroll === days.scrollLeft) {
			$(".js-date-next-month").trigger("click");
		} else {
			scroll = days.scrollLeft;
			days.scrollLeft = scroll + 40;
		}
		$(".js-date-prev").removeClass("inactive");
	});

	setTimeout(setSelectedDatesToCenter, 50);

	$(".js-date-prev-month").on("click", () => {
		pickmeup(datePick).prev();
		const pickMonth = $(".pmu-month.pmu-button")
			.text()
			.toLowerCase();
		const currentMonth = new Date().toLocaleString("ru", { month: "long" });
		setTimeout(setSelectedDatesToCenter, 50);
		if (pickMonth.includes(currentMonth)) {
			$(".js-date-prev-month").addClass("disabled");
		}
	});

	$(".js-date-next-month").on("click", () => {
		pickmeup(datePick).next();

		$(".js-date-prev-month").removeClass("disabled");
	});

	$(".js-data-reset").on("click", e => {
		const element = $(e.currentTarget);
		const show = element.parents(".date__show");
		show.hide();
		pickmeup(datePick).clear();
		getContent();
		setDisabledDates();
		setSelectedDatesToCenter();
	});
}
